// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__I1naC","title":"Info_title__i_tRk","selects":"Info_selects__2Sbk7","requiredAsterisk":"Info_requiredAsterisk__2r9N1"};